module.exports = __webpack_public_path__ + "media/operational-planning_de_ipad_new.6c88cbd9.mp4";